import React from 'react';
import { Container, Row, Col, Form, CardBody, Card } from 'reactstrap';
import UrlInput from '../../common/UrlInput';

const UrlComponent = () => {
    return (
        <React.Fragment>
            <div className="page-content components">
                <Container>
                    <Card>
                        <CardBody>
                            <h2 className="mb-4">URL Input Showcase</h2>
                            <Form className="item-creation">
                                {/* First Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <UrlInput
                                            name="urlWithHelp"
                                            id="urlWithHelpInput"
                                            required={true}
                                            layout="below"
                                            showHelp={true}
                                            helpText="Please enter a valid URL."
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<UrlInput
    name="urlWithHelp"
    id="urlWithHelpInput"
    required={true}
    layout="below"
    showHelp={true}
    helpText="Please enter a valid URL."
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Second Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <UrlInput
                                            name="inlineUrl"
                                            id="inlineUrlInput"
                                            label="Inline URL"
                                            required={true}
                                            layout="inline"
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<UrlInput
    name="inlineUrl"
    id="inlineUrlInput"
    label="Inline URL"
    required={true}
    layout="inline"
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Third Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <UrlInput
                                            name="optionalUrl"
                                            id="optionalUrlInput"
                                            label="Optional URL"
                                            placeholder="Enter a URL (optional)"
                                            required={false}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<UrlInput
    name="optionalUrl"
    id="optionalUrlInput"
    label="Optional URL"
    placeholder="Enter a URL (optional)"
    required={false}
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Fourth Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <UrlInput
                                            name="customValidationUrl"
                                            id="customValidationUrlInput"
                                            required={true}
                                            validationErrorMessage="Please enter a valid URL format."
                                            layout="below"
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<UrlInput
    name="customValidationUrl"
    id="customValidationUrlInput"
    required={true}
    validationErrorMessage="Please enter a valid URL format."
    layout="below"
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default UrlComponent;
